import type { ReactNode } from "react";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";

export const TechnicianStatementMessage = ({
  icon,
  machine,
  title,
  body,
  isAlert = false,
}: {
  icon?: ReactNode;
  machine?: ReactNode;
  title: string;
  body: string;
  isAlert?: boolean;
}) => (
  <Empty
    className={emptyStateVariants({ layout: "workspace" })}
    role={isAlert ? "alert" : undefined}
  >
    <EmptyHeader>
      {machine ? (
        <EmptyMedia>{machine}</EmptyMedia>
      ) : (
        <EmptyMedia variant="icon">{icon}</EmptyMedia>
      )}
      <EmptyTitle>{title}</EmptyTitle>
      <EmptyDescription>{body}</EmptyDescription>
    </EmptyHeader>
  </Empty>
);
